import React from "react";
import AutoTyping, { BlinkCursor } from "react-auto-typing";
import { Link } from "react-router-dom";

const Benefits = () => {
  const scrollHeader = () => {
    window.scroll({ top: 0, behavior: "instant" });
  };
  return (
    <div className="pharmaceutical-benefit-wrapper">
      <div className="section-title">
        <h1 className="title">Benefits of Choosing Soori Corporation</h1>
        <span className="subtitle" aria-hidden="true">
          <AutoTyping
            active // <boolean>
            textRef={"Benefits"}
            writeSpeed={150} // <number>
            deleteSpeed={150} // <number>
            delayToWrite={1000} // <number>
            delayToDelete={2000}
          />
        </span>
      </div>
      <div className="row m-0 mt-4 justify-content-between benefit-container">
        <div className="col-12 col-lg-9">
          <div className="row gap-4">
            <div className="col-12  module-item">
              <div className="title">
                <div>
                  0<span>1</span>
                </div>
              </div>
              <div className="flex-grow-1 description">
                <h4>Industry Expertise</h4>
                <p>
                  Tailored solutions that meet the specific needs of the
                  pharmaceutical industry.
                </p>
              </div>
            </div>
            <div className="col-12  module-item">
              <div className="title">
                <div>
                  0<span>2</span>
                </div>
              </div>
              <div className="flex-grow-1 description">
                <h4>Compliance-first Approach</h4>
                <p>
                  Designed to help you meet the strictest regulatory
                  requirements.
                </p>
              </div>
            </div>
            <div className="col-12  module-item">
              <div className="title">
                <div>
                  0<span>3</span>
                </div>
              </div>
              <div className="flex-grow-1 description">
                <h4>Efficient Asset Management</h4>
                <p>
                  Ensure that critical laboratory and production equipment is
                  always functioning at optimal levels.
                </p>
              </div>
            </div>
            <div className="col-12  module-item">
              <div className="title">
                <div>
                  0<span>4</span>
                </div>
              </div>
              <div className="flex-grow-1 description">
                <h4>Scalable Solutions</h4>
                <p>
                  Our software grows with your company’s production and
                  regulatory demands.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6 col-lg-3 mt-3 my-lg-4 align-items-start d-flex ">
          <div class="pharmaceutical-request-demo-wrapper">
            <p class="text-center">
              Schedule a personalized demo that addresses your unique business
              requirements.
            </p>
            <Link
              class=" btn py-2 px-4 mt-2"
              to="/contact-us"
              onClick={scrollHeader}
            >
              Book a Demo
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Benefits;
